import { SITE_SERVICE } from '../config/sites';
import { IDevice } from '../modules/devices/store/deviceStore';
import { CredentialsValidityResponseDto, GetPinForUserAcApiResponse } from './accessControlApi';
import { api } from './api';
import { IStateResponse } from './legacyApi/legacyApiCommon';
import { RequestMethod } from './legacyFeApi';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createDevice: build.mutation<CreateDeviceApiResponse, CreateDeviceApiArg>({
      query: (queryArg) => ({
        body: queryArg.deviceDto,
        method: RequestMethod.POST,
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/devices`,
      }),
    }),
    createSiteGsmDeviceService: build.mutation<UpdateSiteGsmDeviceServiceApiResponse, UpdateSiteGsmDeviceServiceApiArg>(
      {
        query: (queryArg) => ({
          body: queryArg.siteGsmDeviceServiceDto,
          method: RequestMethod.PUT,
          url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/devices/${queryArg.deviceId}/services/GSM_CALLS`,
        }),
      }
    ),
    deleteSiteDevice: build.mutation<IStateResponse, DeleteSiteDeviceApiArg>({
      query: (queryArg) => ({
        method: RequestMethod.DELETE,
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/devices/${queryArg.deviceId}`,
      }),
    }),
    getApartmentAdminCredentialsValidity: build.query<
      GetApartmentAdminCredentialsValidityApiResponse,
      GetApartmentAdminCredentialsValidityApiArg
    >({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users/${queryArg.userId}/credentials`,
      }),
    }),
    getApartmentAdminPinSettings: build.query<
      GetApartmentAdminPinSettingsApiResponse,
      GetApartmentAdminPinSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/credentials/guest-pin-settings`,
      }),
    }),
    getApartmentPinForUser: build.query<GetPinForUserAcApiResponse, GetApartmentPinForUserApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users/${queryArg.userId}/credentials/pin`,
      }),
    }),
    updateSiteGsmDeviceService: build.mutation<UpdateSiteGsmDeviceServiceApiResponse, UpdateSiteGsmDeviceServiceApiArg>(
      {
        query: (queryArg) => ({
          body: queryArg.siteGsmDeviceServiceDto,
          method: RequestMethod.PUT,
          url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/devices/${queryArg.deviceId}/services/GSM_CALLS`,
        }),
      }
    ),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as gatewayApi };


export type GetApartmentPinForUserApiArg = {
  siteId: string;
  userId: string;
  companyId: string;
  apartmentId: string;
};

export type GetApartmentAdminCredentialsValidityApiResponse =
  /** status 200 Apartment admin credentials validity in site */ CredentialsValidityResponseDto;
export type GetApartmentAdminCredentialsValidityApiArg = {
  siteId: string;
  userId: string;
  companyId: string;
  apartmentId: string;
};
export type GetApartmentAdminPinSettingsApiResponse = /** status 200 guest pin settings */ GuestPinSettingsDto;
export type GetApartmentAdminPinSettingsApiArg = {
  siteId: string;
  companyId: string;
  apartmentId: string;
};

export type UpdateSiteGsmDeviceServiceApiResponse = {
  active?: boolean;
  type: string;
  phoneNumber?: string;
};

export type CreateDeviceApiResponse = IDevice;

export type SiteGsmDeviceServiceDto = {
  active?: boolean;
  type: string;
  phoneNumber: string;
};

export type UpdateSiteGsmDeviceServiceApiArg = {
  apartmentId: string;
  siteId: string;
  companyId: string;
  deviceId: string;
  siteGsmDeviceServiceDto: SiteGsmDeviceServiceDto;
};

export type DeleteSiteDeviceApiArg = {
  apartmentId: string;
  siteId: string;
  companyId: string;
  deviceId: string;
};

export type CreateDeviceApiArg = {
  apartmentId: string;
  siteId: string;
  companyId: string;
  deviceDto: DeviceDto;
};

type DeviceDto = {
  type?: string;
  apartmentId?: string | null;
  externalId?: string;
  name?: string;
  userId?: number;
  services: {
    type: SITE_SERVICE;
    enabled?: boolean;
    phoneNumber?: string;
    active?: boolean;
    externalId?: string;
  }[];
};

export type GuestPinSettingsDto = {
  guestPinLength?: number;
  guestShowQr?: boolean;
};

export const {
  useCreateDeviceMutation,
  useDeleteSiteDeviceMutation,
  useGetApartmentAdminCredentialsValidityQuery,
  useGetApartmentAdminPinSettingsQuery,
  useGetApartmentPinForUserQuery,
  useUpdateSiteGsmDeviceServiceMutation,
} = injectedRtkApi;
